import { css } from '@emotion/react';
import PropTypes from "prop-types";
import React from 'react';
import { EuiCodeBlock, EuiText, EuiSplitPanel, EuiSpacer, EuiTitle, useEuiTheme, EuiBadge, logicalCSS, useIsWithinBreakpoints, useEuiPaddingCSS } from '../../../../../src';
export var ThemeExample = ({
  color,
  type = 'token',
  title,
  description,
  example,
  examplePanel,
  snippet,
  snippetLanguage = 'jsx',
  props
}) => {
  const {
    euiTheme
  } = useEuiTheme();
  const isLargeBreakpoint = useIsWithinBreakpoints(['m', 'l', 'xl']);
  const finalSnippet = snippetLanguage === 'emotion' ? `css\`
  ${snippet}
\`` : snippet;
  return <>
      <EuiSplitPanel.Outer color={isLargeBreakpoint ? color || 'transparent' : 'subdued'} direction="row" css={/*#__PURE__*/css("gap:", euiTheme.size.xl, ";", useEuiPaddingCSS(isLargeBreakpoint ? 'vertical' : undefined).xl, ";:not(:first-child){margin-block-start:", euiTheme.size.xl, ";};label:ThemeExample;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))}>
        <EuiSplitPanel.Inner paddingSize="none" style={{
        flexShrink: 0
      }}>
          {title && <>
              <EuiTitle size="xxs">
                <h3>
                  {title}{' '}
                  {type && <EuiBadge css={/*#__PURE__*/css(logicalCSS('margin-left', euiTheme.size.xs), ";;label:ThemeExample;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))} color={type.includes(' ') ? 'accent' : 'hollow'}>
                      {type}
                    </EuiBadge>}
                </h3>
              </EuiTitle>

              <EuiSpacer />
            </>}

          <EuiText size="s" grow={false}>
            {description}
          </EuiText>
          {props && <>
              <EuiSpacer />
              <EuiCodeBlock transparentBackground paddingSize="none" language="ts">
                {props}
              </EuiCodeBlock>
            </>}
        </EuiSplitPanel.Inner>

        {(example || snippet) && <EuiSplitPanel.Inner paddingSize="none" style={{
        overflow: 'hidden'
      }}>
            <EuiSplitPanel.Outer direction="column" hasBorder={true} hasShadow={false}>
              {example && <EuiSplitPanel.Inner {...examplePanel}>
                  {example}
                </EuiSplitPanel.Inner>}
              <EuiSplitPanel.Inner paddingSize="none" color="subdued">
                {finalSnippet && <EuiCodeBlock whiteSpace="pre" isCopyable={true} paddingSize="m" transparentBackground={true} language={snippetLanguage === 'emotion' ? 'jsx' : snippetLanguage}>
                    {finalSnippet}
                  </EuiCodeBlock>}
              </EuiSplitPanel.Inner>
            </EuiSplitPanel.Outer>
          </EuiSplitPanel.Inner>}
      </EuiSplitPanel.Outer>
    </>;
};
ThemeExample.propTypes = {
  color: PropTypes.any,
  title: PropTypes.node,
  description: PropTypes.node,
  type: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.oneOf([null])]),
  property: PropTypes.string,
  example: PropTypes.node,
  examplePanel: PropTypes.shape({
    /**
       * Padding for all four sides
       */
    paddingSize: PropTypes.any,

    /**
       * When true the panel will grow in height to match `EuiFlexItem`
       */
    grow: PropTypes.bool,
    panelRef: PropTypes.any,

    /**
       * Background color of the panel;
       * Usually a lightened form of the brand colors
       */
    color: PropTypes.any,
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string
  }),
  snippet: PropTypes.node,
  snippetLanguage: PropTypes.any,
  props: PropTypes.node,
  provider: PropTypes.shape({
    property: PropTypes.string,
    type: PropTypes.string
  })
};

try {
  ThemeExample.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/_components/_theme_example.tsx',
    description: '',
    displayName: 'ThemeExample',
    methods: [],
    props: {
      color: {
        defaultValue: null,
        description: '',
        name: 'color',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"primary" | "accent" | "success" | "warning" | "danger" | "subdued" | "plain" | "transparent"',
          value: [{
            value: '"primary"'
          }, {
            value: '"accent"'
          }, {
            value: '"success"'
          }, {
            value: '"warning"'
          }, {
            value: '"danger"'
          }, {
            value: '"subdued"'
          }, {
            value: '"plain"'
          }, {
            value: '"transparent"'
          }]
        }
      },
      title: {
        defaultValue: null,
        description: '',
        name: 'title',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      type: {
        defaultValue: {
          value: 'token'
        },
        description: '',
        name: 'type',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      property: {
        defaultValue: null,
        description: '',
        name: 'property',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      example: {
        defaultValue: null,
        description: '',
        name: 'example',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      examplePanel: {
        defaultValue: null,
        description: '',
        name: 'examplePanel',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'HTMLAttributes<HTMLDivElement> & Omit<_EuiPanelProps, "hasBorder" | "hasShadow" | "borderRadius">'
        }
      },
      snippet: {
        defaultValue: null,
        description: '',
        name: 'snippet',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      snippetLanguage: {
        defaultValue: {
          value: 'jsx'
        },
        description: '',
        name: 'snippetLanguage',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      props: {
        defaultValue: null,
        description: '',
        name: 'props',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      provider: {
        defaultValue: null,
        description: '',
        name: 'provider',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_components/_theme_example.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '{ property?: string; type?: string; }'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}